import React from 'react'

import ElementBase from './ElementBase'

class ElementAudio extends ElementBase {
  html() {
    var settings = this.props.element.settings
    return(
      <div className="audio">
        <button className="button audio">Mehr Inhalte anhören</button>
      </div>
    )
  }
}

export default ElementAudio
